import React from "react";
import styled from "styled-components";
import EasyPaymentButton from "./EasyPaymentButton";

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: ${(props) => props.width};
`;

const EasyDonateButtons = (props) => {
  return (
    <FlexRow>
      <EasyPaymentButton
        payment={props.payment}
        setPayment={props.setPayment}
        value={10}
      />
      <EasyPaymentButton
        payment={props.payment}
        setPayment={props.setPayment}
        value={25}
      />
      <EasyPaymentButton
        payment={props.payment}
        setPayment={props.setPayment}
        value={50}
      />
      <EasyPaymentButton
        payment={props.payment}
        setPayment={props.setPayment}
        value={100}
      />
    </FlexRow>
  );
};

export default EasyDonateButtons;
